import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconNotificationStyle0 = gravityIconIndividualCss;

const GravityIconNotification = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '412e2eca8fe78e4198e61a68d6f4def2788be45b', color: this.color, size: this.size }, h("svg", { key: '8382cc7993dda3b3e4ebe36129385c702da34c55', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a350708ab30d7bfb1ddb38eeba9225e03ae27425', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3C7 3 5.1 6.05 5.1 9.57a10.73 10.73 0 0 1-1.1 4.7.49.49 0 0 0 .44.72h13.1a.5.5 0 0 0 .45-.72 10.52 10.52 0 0 1-1.06-4.64C16.93 6.12 14.66 3 11 3Zm0 1.5h.019c-4.06.014-4.379 3.882-4.379 5.07A12.29 12.29 0 0 1 6 13.49h10.05a12.248 12.248 0 0 1-.63-3.86c0-2.545-1.514-5.119-4.401-5.13h.021H11ZM8.547 17.28A.51.51 0 0 1 9 17h4a.51.51 0 0 1 .36.81 3 3 0 0 1-4.77 0 .51.51 0 0 1-.043-.53Z", fill: "currentColor" }))));
    }
};
GravityIconNotification.style = GravityIconNotificationStyle0;

export { GravityIconNotification as gravity_icon_notification };

//# sourceMappingURL=gravity-icon-notification.entry.js.map